<template>
  <div id="noticeList">
    <div class="common_top_wrap">
      <div class="common_tit">공지사항</div>
      <div class="common_search_wrap">
        <input type="text" v-model="searchParams.searchText" placeholder="제목 키워드 입력"/>
        <div class="btn_search" @click="search(1)">검색</div>
      </div>
    </div>
    <template v-if="isMobile">
      <div class="notice_list_header">
        <div><span>제목</span></div>
        <div><span>첨부</span></div>
      </div>
      <div class="notice_list_wrap">
        <div class="no_list_data" v-if="list.length <= 0">검색 결과가 없습니다.</div>
        <div class="notice_item" :key="'notice_' + item.noticePid" v-for="item in list" @click="showNotice(item)">
          <div><span>{{item.subject}}</span></div>
          <div><span :class="item.fileCount > 0 ? 'file' : ''">첨부파일 있음</span></div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="notice_list_header">
        <div><span>NO</span></div>
        <div><span>제목</span></div>
        <div><span>작성일</span></div>
        <div><span>첨부</span></div>
      </div>
      <div class="notice_list_wrap">
        <div class="no_list_data" v-if="list.length <= 0">검색 결과가 없습니다.</div>
        <div class="notice_item" :key="'notice_' + item.noticePid" v-for="(item, index) in list" @click="showNotice(item)">
          <div><span>{{(pageParams.totalElements - (pageParams.page - 1) * filter.size) - index}}</span></div>
          <div><span>{{item.subject}}</span></div>
          <div><span>{{item.updDate}}</span></div>
          <div><span class="file" v-if="item.fileCount > 0">첨부파일 있음</span></div>
        </div>
      </div>
    </template>
    <div class="list_bottom_wrap">
      <div class="btn_bottom" @click="addNotice" v-if="this.mySession != null && this.mySession.userPid != null && this.mySession.userRole != null">작성</div>
      <div class="common_page_wrap">
        <paginate
          v-model="pageParams.page"
          :pageCount="pageParams.totalPage"
          :clickHandler="search"
          :prevText="'<'"
          :nextText="'>'"
          :containerClass="'page_wrap'">
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import notice from '../../script/notice'

export default {
  data () {
    return {
      isMobile: common.detectMobile(),
      // Common
      mySession: {},
      // Search
      searchTypeList: [],
      searchParams: {
        searchType: '',
        searchText: ''
      },
      // List
      filter: {
        page: 1,
        size: 10
      },
      list: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: 10
      }
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
      }
    })
    if (this.$route.params != null && this.$route.params.searchParams != null) {
      this.searchParams = this.$route.params.searchParams
      this.search(1)
    } else {
      this.search(1)
    }
  },
  methods: {
    search (page) {
      this.filter = {
        page: page,
        size: 10
      }
      delete this.filter['search']
      if (this.searchParams.searchText != null && this.searchParams.searchText.length > 0) {
        this.filter['search'] = this.searchParams.searchText
      }
      this.updateList()
    },
    updateList () {
      notice.getNotice(this.filter, response => {
        console.log('공지사항 목록', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          this.list = data.list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '공지사항 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
      })
    },
    addNotice () {
      this.$router.push({
        name: 'NoticeForm',
        params: {
          searchParams: this.searchParams
        }
      })
    },
    showNotice (item) {
      notice.getNotice({
        noticePid: item.noticePid
      }, response => {
        console.log('공지사항 상세 정보', response)
        if (response.data.resultCode === 1) {
          this.$router.push({
            name: 'NoticeView',
            params: {
              searchParams: this.searchParams,
              data: response.data.result.body
            }
          })
        } else {
          common.amsAlert('retry', '공지사항 정보를 불러오지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
.mobile_wrap #noticeList {
  padding: 0 16px;
  box-sizing: border-box;
}

#noticeList .notice_item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/List.vue